/* joechia-usd-hint v3 — round USD up to 2 significant digits
 * Examples: 106→110, 119→120, 152→160, 210→210, 1064→1100
 * (slightly more expensive in USD, but tourist-friendly clean numbers)
 */
(function () {
  'use strict';
  var IDR_PER_USD = 16000; // update manually when needed

  function parseIDR(text) {
    if (!text) return null;
    text = text.replace(/^[\s ]+|[\s ]+$/g, '');
    var m = text.match(/Rp\s*([\d.,\s ]+)/) || text.match(/([\d]{1,3}(?:[.,\s ]\d{3})+|[\d]{4,})/);
    if (!m) return null;
    var raw = m[1].replace(/[\s ]/g, '');
    if (raw.indexOf('.') >= 0 && raw.indexOf(',') >= 0) raw = raw.replace(/\./g, '').replace(',', '.');
    else if ((raw.match(/\./g) || []).length > 1) raw = raw.replace(/\./g, '');
    else if ((raw.match(/,/g) || []).length > 1) raw = raw.replace(/,/g, '');
    var n = parseFloat(raw);
    return isFinite(n) && n >= 1000 ? n : null;
  }

  // Round UP to 2 significant figures (always slightly more, never less)
  function roundUpTo2Sig(n) {
    if (n <= 0) return 0;
    if (n < 100) {
      // Under $100: round up to nearest 10
      return Math.ceil(n / 10) * 10;
    }
    // 100+: round up to first 2 significant digits
    var magnitude = Math.pow(10, Math.floor(Math.log10(n)) - 1);
    return Math.ceil(n / magnitude) * magnitude;
  }

  function formatUSD(amount) {
    return '≈ $' + Math.round(amount).toLocaleString('en-US');
  }

  function addHints() {
    var nodes = document.querySelectorAll('.m-price-item--regular, .m-price-item--sale');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var parent = el.closest('.m-price__regular, .m-price__sale, .m-product-card__price') || el.parentNode;
      if (parent.querySelector('.jc-usd-hint')) continue;
      var amount = parseIDR(el.textContent);
      if (amount === null) continue;
      var usdRaw = amount / IDR_PER_USD;
      if (usdRaw < 0.5) continue;
      var usd = roundUpTo2Sig(usdRaw);
      var hint = document.createElement('span');
      hint.className = 'jc-usd-hint';
      hint.textContent = formatUSD(usd) + ' USD';
      try {
        parent.appendChild(hint);
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHints);
  } else {
    addHints();
  }
})();
